import { useMediaQuery } from '@material-ui/core';

/**
 * A phone: the width below which core-components swaps the sidebar for the
 * bottom bar. `SidebarPage` decides it with Material UI v4's
 * `theme.breakpoints.down('xs')`, which is this query with the default
 * breakpoints (sm = 600, step 5: `max-width: 600 - 5/100 px`) — the app's
 * theme does not change them. The phone rules of styles.css use the same
 * value, so the layout and the bar switch together.
 */
export const PHONE_MEDIA_QUERY = '(max-width: 599.95px)';

/**
 * Whether the window is a phone's ({@link PHONE_MEDIA_QUERY}). False where
 * `matchMedia` does not exist (jsdom), as Material UI's hook answers there:
 * tests see the desktop layout unless they mock it.
 */
export function useIsPhone(): boolean {
  return useMediaQuery(PHONE_MEDIA_QUERY, { noSsr: true });
}
